import { Task } from "models/schemas";

export interface ITaskGroupProps {
  parentId: string;
  onRefetchTaskGroups?: () => void;
  onRefetchTasks?: () => void;
  taskGroupsLoading?: boolean;
  tasksLoading?: boolean;
}

export type TaskGroupConfig = {
  id: string;
  data: Task;
  rowSpan?: number;
  columnSpan?: number;
  isTasksExpanded?: boolean;
  ratio?: number;
};

export enum TaskTypeEnum {
  TASK_GROUP = "Task Group",
  TASK = "Task",
  SUB_TASK = "Sub Task",
}

export interface TaskListRequest {
  parentTaskIds: string[];
}

export interface TaskListResponse {
  tasks: {
    taskList: Array<Task>;
  };
}

export interface CreateWithTemplateRequest {
  templateId: string;
  parentId: string;
  teamName: string;
  owner: string;
}

export interface CreateTasksFromScanRequest {
  parentId: string;
  teamName: string;
  owner: string;
  tasks: {
    taskList: Array<Task>;
  };
}

export interface CreateWithTemplateResponse {
  success: boolean;
}

export interface UpdateTaskGroupOrderInput {
  tasks: {
    taskList: Array<Task>;
  };
}
